import React from 'react';
import { Routes } from '../../routes';
import GeneralErrorView from '../GeneralErrorView';

export const NotFoundErrorView = () => {

    return <GeneralErrorView 
        title='Page Not Found' message='Sorry, the page you are trying to view doesn&apos;t seem to exist!'
        route={ Routes.Home.buildPath() } buttonText='Home Page' />;
};

export default NotFoundErrorView;